package horcrux.frontend.common.views.collections.collectiondialogs

import horcrux.frontend.common.BooleanState
import horcrux.frontend.common.views.collections.CollectionNavigatorMenuOption
import horcrux.frontend.common.views.collections.CollectionNavigatorState
import horcrux.frontend.common.views.components.containers.DialogView
import mui.material.DialogContentText
import mui.material.Typography
import mui.system.sx
import react.FC
import react.Props
import web.cssom.WhiteSpace


external interface MetadataDetailsDialogProps : Props {
    var title: String
    var detailsText: String
    var collectionNavigatorState: CollectionNavigatorState
    var showDialogState: BooleanState
}


val MetadataDetailsDialog = FC<MetadataDetailsDialogProps> { props ->
    DialogView {
        this.title = CollectionNavigatorMenuOption.COLLECTION_DETAILS.viewName
        this.showDialogState = props.showDialogState
        DialogContentText { +props.title }
        Typography {
            this.sx {
                this.whiteSpace = WhiteSpace.preLine
            }
            +"${props.detailsText}"
        }
    }
}
